import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

/**
 * The page's outgoing Smart Links, used to size the byline's icon reservation before paint.
 *
 * The draft field is only correct for *unpublished* content: a live doc is rendered by the editor
 * yet its content is published, so it must use `contentSmartLinks`.
 *
 * Only `url` is selected; ORS is authoritative for titles, icons and resource types.
 */
export const BylineSmartLinksQuery: GraphQLTaggedNode = graphql`
	query BylineSmartLinksQuery($contentId: ID!, $first: Int!, $smartLinksFromDraft: Boolean!) {
		contentSmartLinks(id: $contentId, first: $first, includeHyperlinks: true)
			@skip(if: $smartLinksFromDraft) {
			nodes {
				url
			}
		}
		confluence_contentSmartLinksForDraft(id: $contentId, first: $first, includeHyperlinks: true)
			@include(if: $smartLinksFromDraft) {
			nodes {
				url
			}
		}
	}
`;
